import { render, staticRenderFns } from "./CompetenceSentenceForm.vue?vue&type=template&id=35d13bf1&scoped=true"
import script from "./CompetenceSentenceForm.vue?vue&type=script&lang=js"
export * from "./CompetenceSentenceForm.vue?vue&type=script&lang=js"
import style0 from "./CompetenceSentenceForm.vue?vue&type=style&index=0&id=35d13bf1&prod&lang=css"
import style1 from "./CompetenceSentenceForm.vue?vue&type=style&index=1&id=35d13bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d13bf1",
  null
  
)

export default component.exports